// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-module--wrapper--17VcU","slimButton":"form-module--slimButton--1WnKm","error":"form-module--error--1Y_4z"};